import request from '@/axios';

/** 分页查询渠道安全配置 */
export const getList = (params) => {
  return request({
    url: '/lebo-security/web/channelSecurityConf/page',
    method: 'get',
    params
  })
}


/** 新增渠道安全配置 */
export const addChannelConfig = (data) => {
  return request({
    url: '/lebo-security/web/channelSecurityConf/saveOrUpdate',
    method: 'post',
    data
  })
}

/** 编辑渠道安全配置 */
export const editChannelConfig = (data) => {
  return request({
    url: '/lebo-security/web/channelSecurityConf/saveOrUpdate',
    method: 'post',
    data
  })
}

/** 删除渠道安全配置 */
export const deleteChannelConfig = (id) => {
  return request({
    url: `/lebo-security/web/channelSecurityConf/remove?id=${id}`,
    method: 'post'
  })
}